module.exports = __webpack_public_path__ + "static/media/56.e69157fd.png";